import React, { createContext, useContext, useState } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ message: '', type: '' });

  const showToast = (message, type = 'info') => {
    setToast({ message, type });
  };

  const showSuccess = (message) => {
    setToast({ message, type: 'success' });
  };

  const showError = (message) => {
    setToast({ message, type: 'error' });
  };

  const showInfo = (message) => {
    setToast({ message, type: 'info' });
  };

  const hideToast = () => {
    setToast({ message: '', type: '' });
  };

  return (
    <ToastContext.Provider value={{ showToast, showSuccess, showError, showInfo, hideToast }}>
      {children}
      <Toast 
        message={toast.message} 
        type={toast.type} 
        onClose={hideToast}
      />
    </ToastContext.Provider>
  );
};
